import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const list = (state: IRootState) => state[prefix].list
